import { useTheme } from '@mui/material/styles';
import { FONTS, AUTH, FEATURES } from '../../../config/app-config';
// src/components/navigation/header/AccountMenu.js
import React, { useState } from 'react';
import {
    Box,
    Typography,
    Menu,
    MenuItem,
    Divider,
    Avatar,
    Tooltip
} from '@mui/material';
import AccountCircle from '@mui/icons-material/AccountCircle';
import ArrowDropDownRounded from '@mui/icons-material/ArrowDropDownRounded';
import { useAuth } from '../../../auth/AuthProvider';

import { ApiDocumentationDialog } from '../../dialogs/ApiDocumentation';

function AccountMenu({
    offlineMode,
    onOpenPortal,
    onOpenAdminDashboard
}) {
    const theme = useTheme();
    const [anchorEl, setAnchorEl] = useState(null);
    const { user, isAdmin, login, logout } = useAuth();
    const [apiOpen, setApiOpen] = useState(false);

    const open = Boolean(anchorEl);

    const handleClick = (e) => {
        if (!user) {
            login();
        } else {
            setAnchorEl(e.currentTarget);
        }
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    // Hilfsfunktion: Initialen aus Name extrahieren
    const getInitials = (name = '') =>
        name
            .split(' ')
            .map((n) => n[0])
            .join('')
            .toUpperCase();

    if (offlineMode || !AUTH.enabled || !FEATURES.account) return null;

    return (
        <>
            {/* Trigger mit Tooltip + statischem Dropdown-Pfeil */}
            <Tooltip title={user ? 'Account' : 'Login'} arrow>
                <Box
                    component="button"
                    type="button"
                    aria-label={user ? 'Open account menu' : 'Log in'}
                    onClick={handleClick}
                    aria-controls={open ? 'account-menu' : undefined}
                    aria-haspopup="true"
                    aria-expanded={open ? 'true' : undefined}
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        cursor: 'pointer',
                        bgcolor: 'transparent',
                        border: 0,
                        minWidth: { xs: 48, sm: 0 },
                        minHeight: { xs: 48, sm: 0 },
                        justifyContent: 'center',
                        p: 0,
                        m: 0,
                        font: 'inherit',
                        color: 'inherit'
                    }}
                >
                    {user ? (
                        <>
                            {/* Eingeloggt: Avatar + (statischer) Dropdown-Pfeil */}
                            <Avatar
                                sx={{
                                    width: 32,
                                    height: 32,
                                    bgcolor: theme.palette.primary.main,
                                    fontSize: '0.675rem',
                                    color: '#fff'
                                }}
                            >
                                {getInitials(user.profile.name)}
                            </Avatar>
                            <ArrowDropDownRounded sx={{ ml: 0.25, fontSize: 22 }} />
                        </>
                    ) : (
                        // Nicht eingeloggt: Icon + "Login"
                        <>
                            <Box sx={{ display: 'flex', alignItems: 'center', pr: 1 }}>
                                <AccountCircle sx={{ fontSize: "2rem" }} />
                            </Box>
                            <Typography
                                variant="caption"
                                sx={{
                                    ml: 0.5,
                                    display: { xs: 'none', lg: 'block' },
                                    fontFamily: FONTS.body,
                                    fontSize: "1rem",
                                }}
                            >
                                Login
                            </Typography>
                        </>
                    )}
                </Box>
            </Tooltip>

            <Menu
                id="account-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                transformOrigin={{ vertical: 'top', horizontal: 'right' }}
            >
                <MenuItem disabled sx={{ fontFamily: FONTS.body, fontStyle: 'italic' }}>
                    {user?.profile?.name || '—'}
                </MenuItem>

                {isAdmin && FEATURES.admin &&
                    [
                        <MenuItem onClick={onOpenAdminDashboard} sx={{ fontFamily: FONTS.body }}>
                            Admin Dashboard
                        </MenuItem>,
                        <Divider sx={{ my: 0.5 }} />
                    ]
                }

                <MenuItem onClick={onOpenPortal} sx={{ fontFamily: FONTS.body }}>
                    Collections
                </MenuItem>

                <MenuItem
                    onClick={() => {
                        setApiOpen(true);
                        handleClose();
                    }}
                    sx={{ fontFamily: FONTS.body }}
                >
                    For Developers ♥
                </MenuItem>

                <MenuItem
                    onClick={() => {
                        logout();
                        handleClose();
                    }}
                    sx={{ fontFamily: FONTS.body }}
                >
                    Logout
                </MenuItem>
            </Menu>

            <ApiDocumentationDialog open={apiOpen} onClose={() => setApiOpen(false)} />
        </>
    );
}

export default AccountMenu;

